import axios from 'axios';
import authService from './AuthService';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api').replace(/\/$/, '');
const API_URL = `${API_BASE}/routers`;

// Función auxiliar para obtener la cabecera de autorización
const getAuthHeader = () => {
    const tokenData = authService.getCurrentToken();
    if (tokenData && tokenData.access_token) {
        return { Authorization: `Bearer ${tokenData.access_token}` };
    }
    return {};
};

const getRouters = () => {
    return axios.get(API_URL + '/', { headers: getAuthHeader() });
};

const createRouter = (routerData) => {
    return axios.post(API_URL + '/', routerData, { headers: getAuthHeader() });
};

const updateRouter = (routerId, routerData) => {
    return axios.put(`${API_URL}/${routerId}`, routerData, { headers: getAuthHeader() });
};

const deleteRouter = (routerId) => {
    return axios.delete(`${API_URL}/${routerId}`, { headers: getAuthHeader() });
};

const routerService = {
    getRouters,
    createRouter,
    updateRouter,
    deleteRouter,
};

export default routerService;
